import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { CreateCottageForm } from "web_myplann/Portfolio/Pages/RealEstateCreate/CreateCottageForm";
import { CreateFlatForm } from "web_myplann/Portfolio/Pages/RealEstateCreate/CreateFlatForm";
import { CreateHouseForm } from "web_myplann/Portfolio/Pages/RealEstateCreate/CreateHouseForm";
import { CreateLandForm } from "web_myplann/Portfolio/Pages/RealEstateCreate/CreateLandForm";
import { useBuildingDraftForm } from "web_myplann/Portfolio/Pages/RealEstateCreate/useBuildingDraftForm";

export const CreateRealEstateForm = () => {
	const { type, onTypeChange, registerSnapshot, getDraft } =
		useBuildingDraftForm();

	if (type === ClientPropertyTypeEnum.Land) {
		return <CreateLandForm type={type} onTypeChange={onTypeChange} />;
	}

	const buildingProps = { type, onTypeChange, registerSnapshot };

	switch (type) {
		case ClientPropertyTypeEnum.House:
			return (
				<CreateHouseForm
					key={type}
					{...buildingProps}
					initialValues={getDraft(type)}
				/>
			);
		case ClientPropertyTypeEnum.Cottage:
			return (
				<CreateCottageForm
					key={type}
					{...buildingProps}
					initialValues={getDraft(type)}
				/>
			);
		default:
			return (
				<CreateFlatForm
					key={type}
					{...buildingProps}
					initialValues={getDraft(ClientPropertyTypeEnum.Flat)}
				/>
			);
	}
};
